import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export const VersionSwitchSelect = ({
  versions,
  version,
  handleVersionSwitch,
  className = 'form-control',
}) => {
  return (
    <select
      name="versionSwitch"
      className={className}
      onChange={handleVersionSwitch}
      value={version}
    >
      {versions.map((item) => (
        <option value={item.currentVersion} key={item.currentVersion}>
          v{item.currentVersion}
        </option>
      ))}
    </select>
  );
};

const VersionChangeModal = ({ versions, version, versionOpen, toggleVersion, handleVersionSwitch }) => {
  return (
    <Modal size="sm" isOpen={versionOpen} toggle={toggleVersion} backdrop="static">
      <ModalHeader toggle={toggleVersion} className="border-bottom">
        <div className="text-center">Switch Version:</div>
      </ModalHeader>
      <ModalBody>
        <div className="row pt-2 pb-2">
          <div className="col-md-12 col-sm-12">
            <VersionSwitchSelect
              versions={versions}
              version={version}
              handleVersionSwitch={handleVersionSwitch}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VersionChangeModal;
